import { Injectable } from '@angular/core';
import { LoggingService } from '../../logging/logic/logging.service';
import { ActionHandler, ActionHandlerType } from '../action-handler';
import { NavController } from '@ionic/angular';
import { AlertService } from '../../alert/alert.service';
import { ClientStateService } from '../../client-state/logic/client-state.service';
import { TranslateService } from '@ngx-translate/core';
import {
  RequiredUserActionLevel,
  RequiredUserActionValidatorService,
} from '../../user-action-validator/required-user-action-validator.service';

@Injectable({
  providedIn: 'root',
})
export class ChangeTourActionHandler implements ActionHandler {
  // Public Member
  public readonly name: ActionHandlerType = 'changetour';

  // Lifecycle
  constructor(
    private logger: LoggingService,
    private translate: TranslateService,
    private alertService: AlertService,
    private clientStateService: ClientStateService,
    private navigationController: NavController,
    private requiredUserActionValidator: RequiredUserActionValidatorService,
  ) {}

  // ActionHandler
  public async executeAction(params?: any): Promise<any> {
    const canExecute = await this.requiredUserActionValidator.triggerLevel(
      RequiredUserActionLevel.CHANGE_TOUR,
    );

    if (!canExecute) {
      return;
    }

    this.logger.log(this.constructor.name, 'execute Action', this.name);
    this.alertService.showAlert(
      this.translate.instant('ACTION.CHANGE-TOUR.ALERT.TITLE'),
      undefined,
      this.translate.instant('ACTION.CHANGE-TOUR.ALERT.MESSAGE'),
      this.translate.instant('ACTION.CHANGE-TOUR.ALERT.CONTINUE'),
      async () => {
        await this.clientStateService.setTourId(undefined);
        await this.navigationController.navigateRoot('/tabbar/mainMenu');
      },
      undefined,
      undefined,
      true,
      'danger',
    );
  }

  // Private Functions
}
